import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";

import Header from "./Header";
import Footer from "./Footer";
import ScrollTop from "./ScrollTop";
import ChatAssistant from "./ChatAssistant";
import { scrollToSectionWhenReady } from "../utils/scroll";

function Layout() {
  const location = useLocation();

  // Navigating between pages should start at the top, unless the navigation
  // asked for a specific section (Header/Footer links) or carries a hash
  // (the Services deep links).
  useEffect(() => {
    const target = location.state?.scrollTo;
    if (target) {
      scrollToSectionWhenReady(target);
      return;
    }
    if (location.hash) {
      scrollToSectionWhenReady(location.hash.slice(1));
      return;
    }
    window.scrollTo({ top: 0, behavior: "auto" });
  }, [location.pathname, location.hash, location.state]);

  return (
    <>
      <Header />
      <main>
        <Outlet />
      </main>
      <Footer />
      <ScrollTop />
      <ChatAssistant />
    </>
  );
}

export default Layout;
